import auditLogs from 'src/features/audit-logs/shared/locales/en';
import tenantAuditLogs from 'src/features/audit-logs/tenant/locales/en';
import authFeature from 'src/features/auth/locales/en';
import bookingRules from 'src/features/booking-rules/locales/en';
import bookings from 'src/features/bookings/locales/en';
import calendarIntegration from 'src/features/calendar-integration/locales/en';
import issues from 'src/features/issues/locales/en';
import statistics from 'src/features/statistics/locales/en';
import employeesGroups from 'src/features/employees-groups/locales/en';
import employees from 'src/features/employees/locales/en';
import tenantManageInvitationDialogue from 'src/features/manage-invitation-to-site/locales/en';
import password from 'src/features/password/locales/en';
import spaceGroups from 'src/features/space-groups/locales/en';
import spaces from 'src/features/spaces/locales/en';
import stateMachine from 'src/state-machine/locales/en';
import auth from './auth.json';
import common from './common.json';
import components from './components.json';
import organizationDetails from './organization-details.json';
import routes from './routes.json';
import validation from './validation.json';

const resources = {
  common,
  auth,
  validation,
  employees,
  organizationDetails,
  routes,
  tenantManageInvitationDialogue,
  password,
  components,
  auditLogs,
  tenantAuditLogs,
  authFeature,
  stateMachine,
  employeesGroups,
  spaces,
  bookingRules,
  spaceGroups,
  bookings,
  calendarIntegration,
  issues,
  statistics,
} as const;

export default resources;
